// localStorage 包裝：無痕視窗、儲存被停用、容量已滿、JSON 損壞時都不丟錯，回到預設值。

export interface KeyValueStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

function defaultStore(): KeyValueStore | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    // 某些瀏覽器設定下，光是讀取 window.localStorage 就會丟錯
    return null;
  }
}

export function readJson<T>(key: string, store: KeyValueStore | null = defaultStore()): T | null {
  try {
    const raw = store?.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writeJson(key: string, value: unknown, store: KeyValueStore | null = defaultStore()): boolean {
  try {
    store?.setItem(key, JSON.stringify(value));
    return !!store;
  } catch {
    return false;
  }
}
